import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { withTheme } from 'theming';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import MarkdownText from '../MarkdownText';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Paragraph = function Paragraph(props) {
  var classesProp = props.classes,
    className = props.className,
    text = props.text;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(MarkdownText, {
    className: classes.text,
    text: text
  })));
};
Paragraph.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  text: PropTypes.string
};
Paragraph.defaultProps = {
  className: null,
  classes: {},
  text: null
};
export default withMemo()(withTheme(Paragraph));